<template>
    <div class="mt-3 mt-md-0">
        <div v-if="object != null">
            <router-link :to="{name: 'inserat-uebersicht', params: {page: $store.state.lastOpenedPage}}" class="btn btn-secondary">Zur Übersicht</router-link>
            <a :href="object.url" target="_blank" class="btn btn-secondary float-right">Vorschau</a>
            <ul class="nav nav-tabs mt-3">
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'category'}"
                       @click="moveTo('category')">
                       Kategorie
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'description'}"
                       @click="moveTo('description')">
                       Beschreibung
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'foto'}"
                       @click="moveTo('foto')">
                       Fotos
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'price'}"
                       @click="moveTo('price')">
                       Preis
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'location'}"
                       @click="moveTo('location')">
                       Standort
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'contact'}"
                       @click="moveTo('contact')">
                       Kontakt
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link"
                       :class="{active: activeTab == 'impressum'}"
                       @click="moveTo('impressum')">
                       Impressum
                    </a>
                </li>
            </ul>
            <div class="p-3 mt-3" v-if="object">
                <category-tab    v-if="activeTab == 'category'"    @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <description-tab v-if="activeTab == 'description'" @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <foto-tab        v-if="activeTab == 'foto'"        @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <price-tab       v-if="activeTab == 'price'"       @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <location-tab    v-if="activeTab == 'location'"    @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <contact-tab     v-if="activeTab == 'contact'"     @nextTab="moveTo" @success="successEdit" @error="errorEdit" :create="false"/>
                <impressum-tab   v-if="activeTab == 'impressum'"                     @success="successEdit" @error="errorEdit" :create="false"/>
            </div>
        </div>
        <b-toast id="error-toast" title="Fehlermeldung" variant="danger" solid>
            {{error}}
        </b-toast>
        <b-toast id="success-toast" variant="success" solid>
            {{success}}
        </b-toast>
    </div>
</template>

<script>
import CategoryTab    from '../../components/object/create/CategoryTab';
import DescriptionTab from '../../components/object/create/DescriptionTab';
import FotoTab        from '../../components/object/create/FotoTab';
import PriceTab       from '../../components/object/create/PriceTab';
import LocationTab    from '../../components/object/create/LocationTab';
import ContactTab     from '../../components/object/create/ContactTab';
import ImpressumTab   from '../../components/object/create/ImpressumTab';
import Inserat        from '../../classes/Inserat';

export default {
    name: 'inserat-edit',
    data: () => {
        return {
            object: null,
            success: '',
            error: '',
            activeTab: 'description',
            arrayTab: [
                'category',
                'description',
                'foto',
                'price',
                'location',
                'contact',
                'impressum',
            ]
        }
    },
    props: ['id'],
    components: {
        CategoryTab,
        DescriptionTab,
        FotoTab,
        PriceTab,
        LocationTab,
        ContactTab,
        ImpressumTab
    },
    created() {
        document.title = 'Inserat bearbeiten';
        this.$store.state.loading = true;
        this.$http.get('/objectApi/getObject?whole=true&id=' + this.id).then(response => {
            let object = JSON.parse(response.data);

            this.$store.state.editObject = object;
            this.object                  = object;
            this.$store.state.loading    = false;
        }).catch(error => {
            this.$store.state.loading = false;
        });

        if(localStorage.getItem('currentObjectTab') !== null && localStorage.getItem('currentObject') !== null){
            this.activeTab = localStorage.getItem('currentObjectTab');
        }
    },
    beforeDestroy() {
        localStorage.removeItem('currentObject');
        localStorage.removeItem('currentObjectTab');
    },
    methods: {
        moveTo(tab) {
            this.activeTab = tab;
        },
        successEdit(success) {
            this.success   = success;
            this.$bvToast.show('success-toast');
        },
        errorEdit(error) {
            this.error     = error;
            this.$bvToast.show('error-toast');
        }
    },
}
</script>

<style scoped>
.nav-link{
    cursor: pointer;
}
.disabled.nav-link{
    cursor: not-allowed !important;
}
</style>
